import * as React from "react";
import { IButton } from "../../domain/message.interface";

interface IAssistantMessageComponentProps {
  message: string;
  buttons: IButton[];
  time: string;
  selectButtons: (buttons: string[]) => void;
  setEnabledInput: (enabled: boolean) => void;
}

export const AssistantMessageComponent: React.FC<
  IAssistantMessageComponentProps
> = (
  { message, buttons, time, selectButtons, setEnabledInput }:
    IAssistantMessageComponentProps,
) => {
  setEnabledInput(!buttons.length);

  const applyTextFormatters = (text: string) => {
    let formatText = text;
    formatText = formatText.replace(/(?:\r\n|\r|\n)/g, "<br />");

    return formatText;
  };

  const handleSelectedButtons = (buttonType: string, currentOption: string) => {
    const selectedButtons: string[] = [];

    if (buttonType === "single") {
      selectedButtons.push(currentOption);
    }

    buttons.forEach((button) => {
      button.options.forEach((option) => {
        const checkbox = document.getElementById(option.id) as HTMLInputElement;
        if (checkbox?.checked && buttonType === "multiple") {
          selectedButtons.push(option.label);
        }

        if (
          checkbox?.checked && option.label !== currentOption &&
          buttonType === "single"
        ) {
          checkbox.checked = false;
        }
      });
    });

    selectButtons(selectedButtons);
  };

  return (
    <div className="flex flex-col bg-white p-4 rounded-lg shadow-md max-w-[390px] leading-1.5 float-left">
      <div className="flex items-center space-x-2 rtl:space-x-reverse">
        <div className="text-[#4d4e53] text-base font-normal">
          <p
            dangerouslySetInnerHTML={{
              __html: applyTextFormatters(message),
            }}
          >
          </p>
          <ul>
            {buttons.map((button) => (
              button.options.map((option, index) => (
                <li key={index} className="mt-2">
                  <input
                    type="checkbox"
                    id={`${option.id}`}
                    className="hidden peer"
                    onChange={() => {
                      handleSelectedButtons(button.subType, option.label);
                    }}
                  />
                  <label
                    htmlFor={`${option.id}`}
                    className="
                      flex items-center cursor-pointer 
                      bg-[#B4DCFA] text-[#000050] 
                      dark:bg-[#242459] dark:text-[#B4DCFA]
                      text-base font-normal p-2 rounded-lg shadow-sm 
                      transition-all duration-200
                      peer-checked:bg-[#FA8982] dark:peer-checked:bg-[#690037]
                      peer-checked:border-2 peer-checked:border-[#D94A41] dark:peer-checked:border-[#FA5A50]
                    "
                  >
                    {option.label}
                  </label>
                </li>
              ))
            ))}
          </ul>
        </div>
        <span className="text-[#A5AAB6] text-xs block text-right self-end">
          {time}
        </span>
      </div>
    </div>
  );
};
